var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", { staticStyle: { "margin-top": "0" } }, [
        _vm._v(_vm._s(_vm.$t("aimAnalytics.title"))),
      ]),
      _c("p", { staticStyle: { color: "#909399", "margin-top": "-8px" } }, [
        _vm._v(" " + _vm._s(_vm.$t("aimAnalytics.descIntro")) + " "),
        _c("code", [_vm._v("aim_daily_rollup")]),
        _vm._v(
          " " +
            _vm._s(_vm.$t("aimAnalytics.descTable")) +
            " " +
            _vm._s(_vm.$t("aimAnalytics.superAdminOnly")) +
            " "
        ),
      ]),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.summaryLoading,
              expression: "summaryLoading",
            },
          ],
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("aimAnalytics.overview")))]),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("aimAnalytics.totalReadings"))),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "stat-value",
                          staticStyle: { color: "#409eff" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.fmt(
                                _vm.summary.ozet &&
                                  _vm.summary.ozet.toplam_okuma
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("aimAnalytics.totalSessions"))),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "stat-value",
                          staticStyle: { color: "#67c23a" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.fmt(
                                _vm.summary.ozet &&
                                  _vm.summary.ozet.toplam_oturum
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("aimAnalytics.devices"))),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.fmt(_vm.summary.ozet && _vm.summary.ozet.cihaz)
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "stat-card", attrs: { shadow: "hover" } },
                    [
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("aimAnalytics.users"))),
                      ]),
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.fmt(
                              _vm.summary.ozet && _vm.summary.ozet.kullanici
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.summary.ozet
            ? _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    color: "#909399",
                    "font-size": "13px",
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("aimAnalytics.dataRange")) + " "),
                  _c("b", [_vm._v(_vm._s(_vm.summary.ozet.ilk_gun))]),
                  _vm._v(" - "),
                  _c("b", [_vm._v(_vm._s(_vm.summary.ozet.son_gun))]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("aimAnalytics.dayDeviceRecords", {
                          n: _vm.fmt(_vm.summary.ozet.gun_kayit),
                        })
                      ) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("aimAnalytics.monthlyTrend")))]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.summaryLoading,
                  expression: "summaryLoading",
                },
              ],
              attrs: {
                data: _vm.summary.aylik || [],
                border: "",
                stripe: "",
                size: "small",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("aimAnalytics.month"), prop: "ay" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.readings"),
                  prop: "okuma",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.okuma),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.sessions"),
                  prop: "oturum",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.oturum),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.devices"),
                  prop: "cihaz",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.cihaz),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.users"),
                  prop: "kullanici",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.kullanici),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "16px" },
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
              },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("b", [_vm._v(_vm._s(_vm.$t("aimAnalytics.dailyTrend")))]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "140px" },
                  attrs: { size: "mini" },
                  on: { change: _vm.loadDaily },
                  model: {
                    value: _vm.days,
                    callback: function ($$v) {
                      _vm.days = $$v
                    },
                    expression: "days",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      value: 7,
                      label: _vm.$t("aimAnalytics.lastNDays", { n: 7 }),
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 30,
                      label: _vm.$t("aimAnalytics.lastNDays", { n: 30 }),
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 90,
                      label: _vm.$t("aimAnalytics.lastNDays", { n: 90 }),
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 180,
                      label: _vm.$t("aimAnalytics.lastNDays", { n: 180 }),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dailyLoading,
                  expression: "dailyLoading",
                },
              ],
              attrs: {
                data: _vm.daily,
                border: "",
                stripe: "",
                size: "small",
                "max-height": "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: _vm.$t("aimAnalytics.day"), prop: "gun" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.readings"),
                  prop: "okuma",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.okuma),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.sessions"),
                  prop: "oturum",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.oturum),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.devices"),
                  prop: "cihaz",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.cihaz),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.users"),
                  prop: "kullanici",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.kullanici),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
              },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("b", [_vm._v(_vm._s(_vm.$t("aimAnalytics.mostActiveCanes")))]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "140px" },
                  attrs: { size: "mini" },
                  on: { change: _vm.loadTop },
                  model: {
                    value: _vm.topLimit,
                    callback: function ($$v) {
                      _vm.topLimit = $$v
                    },
                    expression: "topLimit",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      value: 20,
                      label: _vm.$t("aimAnalytics.topN", { n: 20 }),
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 50,
                      label: _vm.$t("aimAnalytics.topN", { n: 50 }),
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 100,
                      label: _vm.$t("aimAnalytics.topN", { n: 100 }),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.topLoading,
                  expression: "topLoading",
                },
              ],
              attrs: {
                data: _vm.topCanes,
                border: "",
                stripe: "",
                size: "small",
                "max-height": "500",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.caneId"),
                  prop: "cane_id",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.readings"),
                  prop: "okuma",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.okuma),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.sessions"),
                  prop: "oturum",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.oturum),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.activeDays"),
                  prop: "aktif_gun",
                  align: "right",
                  formatter: (r) => _vm.fmt(r.aktif_gun),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("aimAnalytics.lastDay"),
                  prop: "son_gun",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }